module.exports = __webpack_public_path__ + "img/skype.d1252da7.png";